import { api } from "@/lib/api";

const KEY_LS = "isoquest.auth";
const KEY_SS = "isoquest.auth.session";

export const authStorage = {
  load() {
    try {
      const ls = localStorage.getItem(KEY_LS);
      if (ls) return JSON.parse(ls);
      const ss = sessionStorage.getItem(KEY_SS);
      if (ss) return JSON.parse(ss);
    } catch { /* ignore */ }
    return null;
  },
  save(auth, remember) {
    const json = JSON.stringify(auth);
    if (remember) {
      localStorage.setItem(KEY_LS, json);
      sessionStorage.removeItem(KEY_SS);
    } else {
      sessionStorage.setItem(KEY_SS, json);
      localStorage.removeItem(KEY_LS);
    }
    window.dispatchEvent(new Event("isoquest:auth-changed"));
  },
  clear() {
    localStorage.removeItem(KEY_LS);
    sessionStorage.removeItem(KEY_SS);
    localStorage.removeItem("isoquest.activeAccountEmail");
    window.dispatchEvent(new Event("isoquest:auth-changed"));
  },
};

export const auth = {
  async login({ email, password, remember }) {
    const data = await api.post("/auth/login", { email, password, remember_me: !!remember }).then(r => r.data);
    authStorage.save(data, remember);
    try { localStorage.setItem("isoquest.activeAccountEmail", JSON.stringify(data.email)); } catch { /* ignore */ }
    window.dispatchEvent(new Event("isoquest:account-changed"));
    return data;
  },
  async refreshMe() {
    try {
      const me = await api.get("/auth/me").then(r => r.data);
      const existing = authStorage.load();
      if (existing) authStorage.save({ ...existing, ...me }, !!localStorage.getItem(KEY_LS));
      return me;
    } catch {
      return null;
    }
  },
  logout() {
    api.post("/auth/logout").catch(() => {});
    authStorage.clear();
  },
  current: () => authStorage.load(),
  isAuthenticated: () => !!authStorage.load()?.access_token,
};
